// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"3bf8780c","513":"12d6cba3","703":"2d8fd24a","787":"24a482b4"}[chunkId] + ".chunk.js";
};